(function () {
  'use strict';
  var WEBHOOK_URL    = 'https://novaro-crm.netlify.app/.netlify/functions/handle-inquiry';
  var WEBHOOK_SECRET = 'novaro-geheim-2026';

  function formToObj(form) {
    var obj = {};
    new FormData(form).forEach(function (v, k) {
      var n = k.match(/^contact\[(.+?)\]$/);
      if (n) { obj.contact = obj.contact || {}; obj.contact[n[1]] = v; }
      else obj[k] = v;
    });
    return obj;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('nv-form') || document.querySelector('form[action="/contact"]');
    if (!form) return;

    form.addEventListener('submit', function () {
      var payload    = formToObj(form);
      payload.quelle = 'novaro-rent.de/Anfrage-Formular';
      payload.page   = window.location.href;

      fetch(WEBHOOK_URL, {
        method : 'POST',
        headers: {
          'Content-Type'   : 'application/json',
          'X-Novaro-Secret': WEBHOOK_SECRET
        },
        body: JSON.stringify(payload),
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.success) {
            console.log('[Novaro CRM] ✓ Case ' + d.case_id + ' | Customer ' + d.customer_id + (d.customer_new ? ' (neu)' : ' (vorhanden)'));
          }
        })
        .catch(function (e) {
          console.warn('[Novaro CRM] Fehler:', e.message);
        });
    });

    console.log('[Novaro CRM] Sync aktiv');
  });
})();